var column0 = 4,        // CREDITS, INFO
    column1 = 194,      // LINES, LINEBET
    column2 = 422,      // WIN, TOTALBET
    column3 = 612,      // BETMAX, BETMIN
    column4 = 750,      // GAMBLE, AUTOPLAY
    column5 = 888,      // START, STOP, COLLECT, FINISH
    row0 = 632,         //
    row1 = 701,         //
    arrow_left_width = 53,       // ширина стрелки влево
    line_bet_button_width = 116, // ширина кнопок изменения линий и ставки
    line_bet_frame_width = 222,  // полная ширина кнопок изменения линий и ставки
    narrow_frame_width = 184,    // ширина всех остальныех информационных рамок
    text_vertical_offset = 32;   // вертикальное смещение текста в рамке (верх текста)

module.exports = {
    common: {
        font:'user_interface_font'
    },

    buttons: {
        spin: {
            frames:{
                normal:'ru_start_normal.png',
                pressed:'ru_start_pressed.png',
                disabled:'ru_start_disabled.png',
                hover: 'ru_start_hover.png'
            },
            position:{x:column5, y:row0}
        },

        collect: {
            frames:{
                normal:'ru_collect_normal.png',
                pressed:'ru_collect_pressed.png',
                disabled:'ru_collect_disabled.png',
                hover: 'ru_collect_hover.png'
            },
            position:{x:column5, y:row0}
        },

        stop: {
            frames:{
                normal:'ru_stop_normal.png',
                pressed:'ru_stop_pressed.png',
                disabled:'ru_stop_disabled.png',
                hover: 'ru_stop_hover.png'
            },
            position:{x:column5, y:row0}
        },

        start: {
            frames:{
                normal:'ru_start_normal.png',
                pressed:'ru_start_pressed.png',
                disabled:'ru_start_disabled.png',
                hover: 'ru_start_hover.png'
            },
            position:{x:column5, y:row0}
        },

        finish: {
            frames:{
                normal:'ru_finish_normal.png',
                pressed:'ru_finish_pressed.png',
                disabled:'ru_finish_disabled.png',
                hover: 'ru_finish_hover.png'
            },
            position:{x:column5, y:row0}
        },

        info: {
            frames:{
                normal:'ru_info_normal.png',
                pressed:'ru_info_pressed.png',
                disabled:'ru_info_disabled.png',
                hover: 'ru_info_hover.png'
            },
            position:{x:column0, y:row1}
        },

        gamble: {
            frames:{
                normal:'ru_gamble_normal.png',
                pressed:'ru_gamble_pressed.png',
                disabled:'ru_gamble_disabled.png',
                hover: 'ru_gamble_hover.png'
            },
            position:{x:column4, y:row0}
        },

        betmax: {
            frames:{
                normal:'ru_bet_max_normal.png',
                pressed:'ru_bet_max_pressed.png',
                disabled:'ru_bet_max_disabled.png',
                hover: 'ru_bet_max_hover.png'
            },
            position:{x:column3, y:row0}
        },

        betmin: {
            frames:{
                normal:'ru_bet_min_normal.png',
                pressed:'ru_bet_min_pressed.png',
                disabled:'ru_bet_min_disabled.png',
                hover: 'ru_bet_min_hover.png'
            },
            position:{x:column3, y:row0}
        },

        autoplay: {
            frames:{
                normal:'ru_autoplay_normal.png',
                pressed:'ru_autoplay_pressed.png',
                disabled:'ru_autoplay_disabled.png',
                hover: 'ru_autoplay_hover.png'
            },
            position:{x:column4, y:row0}
        },

        autoplayoff: {
            frames:{
                normal:'ru_autoplayoff_normal.png',
                pressed:'ru_autoplayoff_pressed.png',
                disabled:'ru_autoplayoff_disabled.png',
                hover: 'ru_autoplayoff_hover.png'
            },
            position:{x:column4, y:row0}
        },

        menu: {
            frames:{
                normal:'ru_menu_normal.png',
                pressed:'ru_menu_pressed.png',
                disabled:'ru_menu_disabled.png',
                hover: 'ru_menu_hover.png'
            },
            position:{x:2, y:2}
        },

        decrease_lines: {
            frames:{
                normal:'ru_arrow_left_normal.png',
                pressed:'ru_arrow_left_pressed.png',
                disabled:'ru_arrow_left_disabled.png',
                hover: 'ru_arrow_left_hover.png'
            },
            position:{x:column1, y:row0}
        },

        increase_lines: {
            frames:{
                normal:'ru_arrow_right_normal.png',
                pressed:'ru_arrow_right_pressed.png',
                disabled:'ru_arrow_right_disabled.png',
                hover: 'ru_arrow_right_hover.png'
            },
            position:{x:column1 + arrow_left_width + line_bet_button_width, y:row0}
        },

        lines: {
            frames:{
                normal:'ru_lines_normal.png',
                pressed:'ru_lines_pressed.png',
                disabled:'ru_lines_disabled.png',
                hover: 'ru_lines_hover.png'
            },
            position:{x:column1 + arrow_left_width, y:row0}
        },

        decrease_linebet: {
            frames:{
                normal:'ru_arrow_left_normal.png',
                pressed:'ru_arrow_left_pressed.png',
                disabled:'ru_arrow_left_disabled.png',
                hover: 'ru_arrow_left_hover.png'
            },
            position:{x:column1, y:row1}
        },

        increase_linebet: {
            frames:{
                normal:'ru_arrow_right_normal.png',
                pressed:'ru_arrow_right_pressed.png',
                disabled:'ru_arrow_right_disabled.png',
                hover: 'ru_arrow_right_hover.png'
            },
            position:{x:column1 + arrow_left_width + line_bet_button_width, y:row1}
        },

        linebet: {
            frames:{
                normal:'ru_line_bet_normal.png',
                pressed:'ru_line_bet_pressed.png',
                disabled:'ru_line_bet_disabled.png',
                hover: 'ru_line_bet_hover.png'
            },
            position:{x:column1 + arrow_left_width-12, y:row1}
        },
        next: {
            frames: {
                normal:'ru_next_normal.png',
                hover: 'ru_next_hover.png',
                pressed:'ru_next_pressed.png',
                disabled:'ru_next_disabled.png'
            },
            position:{x:795+5,y:768-100+25}
        },
        exit: {
            frames: {
                normal:'ru_exit_normal.png',
                hover: 'ru_exit_hover.png',
                pressed:'ru_exit_pressed.png',
                disabled:'ru_exit_disabled.png'
            },
            position:{x:417, y:768-100+25}
        },
        back: {
            frames: {
                normal:'ru_back_normal.png',
                hover: 'ru_back_hover.png',
                pressed:'ru_back_pressed.png',
                disabled:'ru_back_disabled.png'
            },
            position:{x:17+25, y:768-100+25}
        }
    },

    frames: {
        lines:{
            frame:'ru_lines_line_bet.png',
            text_position:{x:line_bet_frame_width / 2, y:text_vertical_offset},
            text_align:{x:0.5, y:0.5},
            position:{x:column1, y:row0}
        },

        line_bet:{
            frame:'ru_lines_line_bet.png',
            text_position:{x:line_bet_frame_width / 2, y:text_vertical_offset},
            text_align:{x:0.5,y:0.5},
            position:{x:column1, y:row1}
        },

        win:{
            frame:'ru_win_frame.png',
            text_position:{x:narrow_frame_width / 2, y:text_vertical_offset},
            text_align:{x:0.5, y:0.5},
            position:{x:column2, y:row0}
        },

        credits:{
            frame:'ru_credits.png',
            text_position:{x:narrow_frame_width / 2, y:text_vertical_offset},
            text_align:{x:0.5, y:0.5},
            position:{x:column0, y:row0}
        },

        total_bet:{
            frame:'ru_total_bet.png',
            text_position:{x:narrow_frame_width / 2, y:text_vertical_offset},
            text_align:{x:0.5, y:0.5},
            position:{x:column2, y:row1}
        }
    }
};



//////////////////
// WEBPACK FOOTER
// ./cfg/userinterface-config.js
// module id = 17
// module chunks = 0